"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEventListener = exports.notifyEventListenersAndAwaitHandlers = exports.notifyEventListeners = void 0;
const eventListeners = {};
const notifyEventListeners = (type, ...args) => {
    eventListeners[type]?.forEach(listener => {
        listener.handleEvent(...args);
    });
};
exports.notifyEventListeners = notifyEventListeners;
const notifyEventListenersAndAwaitHandlers = (type, ...args) => Promise.all(Array.from(eventListeners[type] ?? []).map(async (listener) => {
    await listener.handleEvent(...args);
}));
exports.notifyEventListenersAndAwaitHandlers = notifyEventListenersAndAwaitHandlers;
const addEventListener = (type, handler) => {
    // If there is no listener set for the event type, just create it
    if (!eventListeners[type]) {
        eventListeners[type] = new Set();
    }
    const listener = {
        handleEvent: handler,
        remove: () => {
            eventListeners[type].delete(listener);
        },
    };
    eventListeners[type].add(listener);
    return {
        remove: () => {
            listener.remove();
        },
    };
};
exports.addEventListener = addEventListener;
